import { render, staticRenderFns } from "./bidding-register.vue?vue&type=template&id=3eceafe2&scoped=true"
import script from "./bidding-register.vue?vue&type=script&lang=js"
export * from "./bidding-register.vue?vue&type=script&lang=js"
import style0 from "./bidding-register.vue?vue&type=style&index=0&id=3eceafe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eceafe2",
  null
  
)

export default component.exports